<div class="content-container">

  @for (webcam of webcams; track webcam) {
    <div>
      <h4>{{webcam['location' + crtLang.toUpperCase()]}}</h4>
      <p class="text-justify">{{webcam['description' + crtLang.toUpperCase()]}}</p>
      @if (webcam.imageUrl) {
        <div class="text-center mb-4">
          <img class="rounded w-100 mw-100" [src]="webcam.imageUrl"
            alt="{{ 'services.webcam.modal.waiting' | translate }}"/>
          </div>
        }
      </div>
    }
  </div>
